<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section class="card" *ngIf="!uploadedData">
      <div class="card-header d-block">
        <h4>{{ "UPLOAD_EMPLOYEE_DATA" | translate }}</h4>
        <p>{{ "LAST_UPDATE" | translate }}: {{ _utilService.formatDate(_utilService.themeConfiguration.last_employee_contracts_update, "DD/MM/YYYY HH:mm:ss") }}</p>
      </div>
      <div class="card-body">
        <div class="custom-file col-4">
          <input class="custom-file-input" type="file" lang="it" id="resignation-upload" accept="application/vnd.sealed.xls" (change)="handlerChangeFileInput($event)" />
          <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
          <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
        </div>
      </div>
    </section>

    <ngb-alert [type]="'danger'" [dismissible]="false" class="card w-100 mb-2" [ngClass]="openedErrorTab === 'danger1' ? 'active' : ''" *ngIf="uploadedData && errors.length > 0">
      <h4 class="alert-heading py-1" (click)="openedErrorTab = openedErrorTab === 'danger1' ? '' : 'danger1'">{{ "EMPLOYEES_NOT_FOUND" | translate }} ({{ errors.length }})</h4>
      <section class="px-1" [ngClass]="openedErrorTab === 'danger1' ? 'alert-body' : 'd-none'">
        <ul class="mt-1">
          <li *ngFor="let fc of errors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>

    <ngb-alert [type]="'danger'" [dismissible]="false" class="card w-100 mb-2" [ngClass]="openedErrorTab === 'danger2' ? 'active' : ''" *ngIf="uploadedData && updateErrors.length > 0">
      <h4 class="alert-heading py-1" (click)="openedErrorTab = openedErrorTab === 'danger2' ? '' : 'danger2'">{{ "ERRORS_UPDATING_CONTRACTS" | translate }} ({{ updateErrors.length }})</h4>
      <section class="px-1" [ngClass]="openedErrorTab === 'danger2' ? 'alert-body' : 'd-none'">
        <ul class="mt-1">
          <li *ngFor="let fc of updateErrors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>

    <section class="card" *ngIf="uploadedData">
      <div class="card-header border-bottom">
        <h4 class="mb-0">{{ "UPLOADED_DATA_SUMMARY" | translate }}</h4>
        <div class="text-right">
          <button class="btn btn-outline-secondary mr-1" *ngIf="!hideUploadButton" (click)="uploadedData = false; processedItems = 0; uploadedData = null">{{ "RESET" | translate }}</button>
          <button class="btn btn-primary" *ngIf="!hideUploadButton" (click)="update()">{{ "UPLOAD" | translate }}</button>
          <span *ngIf="hideUploadButton && !startUpdating">{{ "CALCULATING_EMPLOYEES_CONTRACTS_COSTS" | translate }}: {{ processedItems }}/{{ uploadedData.length }} </span>
          <span *ngIf="hideUploadButton && startUpdating">{{ "UPDATING_EMPLOYEES_CONTRACTS_COSTS" | translate }}: {{ processedItems }}/{{ uploadedData.length }} </span>
        </div>
      </div>
      <div class="card-header row">
        <div class="col-md-3 col-12 font-weight-bold">{{ "COMPLETE_NAME" | translate }}</div>
        <div class="col-md-1 col-12 font-weight-bold">{{ "LEVEL" | translate }}</div>
        <div class="col-md-1 col-12 font-weight-bold">{{ "BADGE_NUMBER" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "SALARY_GROSS_MONTH_12" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "SALARY_YEARLY_GROSS" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "CALCULATE_COSTS" | translate }}</div>
        <div class="col-md-1 col-12 font-weight-bold">{{ "STATUS.STATUS" | translate }}</div>
      </div>
      <div class="card-body row px-0" id="records">
        <div class="record border-bottom d-flex align-items-center py-1 col-12" *ngFor="let record of uploadedData">
          <div class="col-md-3 col-12">
            <a [routerLink]="'/dashboard/user/profile/' + record.user_hash" target="_blank">{{ record.complete_name }}</a>
          </div>
          <div class="col-md-1 col-12">{{ record.level }}</div>
          <div class="col-md-1 col-12">{{ record.badge_number }}</div>
          <div class="col-md-2 col-12">{{ _utilService.addDotsToNumber(record.net_monthly_12) }}&euro;</div>
          <div class="col-md-2 col-12">{{ _utilService.addDotsToNumber(record.salary_yearly_gross) }}&euro;</div>
          <div class="col-md-2 col-12">
            <span class="bit-small-loading" *ngIf="record.status_calculating === 0">
              <img [width]="70" src="../../../../../assets/images/misc/bit-loading-animation.gif" alt="bit" />
            </span>
            <span *ngIf="record.status_calculating === 1" class="text-success d-block mt-05 mb-05">
              <span [data-feather]="'check-circle'" [size]="22"></span>
            </span>
          </div>
          <div class="col-md-1 col-12">
            <span class="badge badge-light-secondary text-dark" *ngIf="record.status_update === 0">{{ "STATUS.PENDING" | translate }}</span>
            <span class="badge badge-light-warning text-dark" *ngIf="record.status_update === 1">{{ "STATUS.PROCESSING" | translate }}</span>
            <span class="badge badge-light-success text-dark" *ngIf="record.status_update === 2">{{ "STATUS.COMPLETED" | translate }}</span>
            <span class="badge badge-light-danger text-dark" *ngIf="record.status_update === 3">{{ "STATUS.ERROR" | translate }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
